import styled from 'styled-components';

import { themed } from '@/shared/ui/core';

export const ShiftModalStyled = styled.div.attrs({
  className: 'ShiftModalStyled',
})`
  .modal__dialog {
    padding: 1.75rem 0.75rem;
  }
`;

export const ModalInner = styled.div.attrs({
  className: 'ModalInner',
})``;

export const ModalHeader = styled.div.attrs({
  className: 'ModalHeader',
})`
  padding: 0.5rem;

  .Title {
    font-size: 1.625rem;
    margin-bottom: 0;
    line-height: 32px;
    color: ${themed('primary.main')};
    margin-bottom: 0.25rem;
  }

  .Text {
    font-size: 1rem;
    line-height: 20px;
    margin-bottom: 0;
    max-width: 21rem;
  }
`;

export const CarouselWrapper = styled.div.attrs({
  className: 'CarouselWrapper',
})`
  .slick-slider {
    .slick-dots {
      li {
        button {
          width: 1rem;
          height: 1rem;
          margin-right: 1rem;
        }
      }
      .slick-active {
        button {
          background-color: ${themed('primary.main')};
          border: none;
        }
      }
    }
  }
`;
